module.exports = __webpack_public_path__ + "img/y- (18).80402045.jpg";